import { render, staticRenderFns } from "./orgEdit.vue?vue&type=template&id=2f2d0a48&scoped=true"
import script from "./orgEdit.vue?vue&type=script&lang=ts"
export * from "./orgEdit.vue?vue&type=script&lang=ts"
import style0 from "./orgEdit.vue?vue&type=style&index=0&id=2f2d0a48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2d0a48",
  null
  
)

export default component.exports